<template>
<div
    class="content-wrapper"
    style="min-height: 873px;"
>
    <div>
        <section class="content">

            <div class="row">
                <!-- Left col -->
                <section class="col-lg-8 connectedSortable">

                    <div class="box">
                        <div class="box-header">
                            <h3 class="box-title">{{ $t('USER CREATION') }}</h3>
                        </div>
                        <!-- /.box-header -->
                        <div class="box-body">
                            <div class="col col-sm-10">

                                <section class="content col-sm-6 border border-dark">

                                    <form
                                        v-on:submit.prevent
                                        class="form"
                                    >

                                        <div class="input-group">
                                            <span class="input-group-addon">{{ $t('USERS.NAME') }}</span>
                                            <input
                                                type="text"
                                                v-model="name"
                                                class="form-control"
                                            >
                                        </div>
                                        <div class="form-group has-error">
                                            <label
                                                class="control-label"
                                                for="inputError"
                                            >
                                                {{ error_message_name | translate}}
                                                </label>
                                        </div>
                                        <br>

                                        <div class="input-group">
                                            <span class="input-group-addon">{{ $t('USERS.LASTNAME') }}</span>
                                            <input
                                                type="text"
                                                v-model="lastname"
                                                class="form-control"
                                            >
                                        </div>
                                        <div class="form-group has-error">
                                            <label
                                                class="control-label"
                                                for="inputError"
                                            >
                                                {{ error_message_lastname | translate}}
                                                </label>
                                        </div>
                                        <br>

                                        <div class="input-group">
                                            <span class="input-group-addon">{{ $t('USERS.ROLL') }}</span>

                                            <select
                                                v-model="roll"
                                                class="form-control"
                                            >

                                                <option value="Administrator">{{ $t("ADMINISTRATOR")}}</option>
                                                <option value="Financial_User">{{ $t("FINANTIAL")}}</option>
                                                <option value="Support_User">{{ $t("SUPPORT")}}</option>
                                                <option value="Sales_User">{{$t("SALES")}}</option>

                                                </select>
                                        </div>
                                        <div class="form-group has-error">
                                            <label
                                                class="control-label"
                                                for="inputError"
                                            >
                                                {{ error_message_roll | translate}}
                                                </label>
                                        </div>
                                        <br>

                                        <div class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                            <input
                                                type="email"
                                                v-model="email"
                                                class="form-control"
                                            >
                                        </div>
                                        <div class="form-group has-error">
                                            <label
                                                class="control-label"
                                                for="inputError"
                                            >
                                                {{ error_message_email | translate}}
                                                </label>
                                        </div>
                                        <br>

                                        <div class="input-group">
                                            <span class="input-group-addon">{{ $t('USERS.PASSWORD') }}</span>
                                            <input
                                                type="password"
                                                v-model="pass"
                                                class="form-control"
                                            >

                                                <span class="input-group-addon"><i class="fa fa-eye"></i></span>
                                        </div>
                                        <div class="form-group has-error">
                                            <label
                                                class="control-label"
                                                for="inputError"
                                            >
                                                {{ error_message_password | translate}}
                                                </label>
                                        </div>
                                        <br>

                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            @click="create"
                                        >{{ $t('USERS.CREATE') }}</button>

                                            <button
                                                class="btn btn-default"
                                                @click="cancel"
                                            >{{ $t('CANCEL') }}</button>

                                                </form>
                                </section>
                            </div>
                        </div>
                        <!-- /.box-body -->
                    </div>

                </section>


            </div>

        </section>

        <aside class="control-sidebar control-sidebar-dark">

        </aside>

    </div>
    </div>
</template>



<script>
import swal from "sweetalert";

export default {
    name: "userForm",
    data() {
        return {
            name: "",
            lastname: "",
            pass: "",
            roll: "",
            email: "",
            error_message_name: "",
            error_message_lastname: "",
            error_message_roll: "",
            error_message_email: "",
            error_message_password: ""
        };
    },
    methods: {
        create() {
            let self = this;
            this.$store.state.services.userService
                .create({
                        name: self.name,
                        lastname: self.lastname,
                        password: self.pass,
                        email: self.email,
                        roll: self.roll
                    },
                    JSON.parse(self.$store.getters.user).token
                )
                .then(response => {
                    swal({
                        title: response.data,
                        icon: "success",
                        dangerMode: false
                    }).then(response => {
                        if (response) {
                            self.$router.push("/users");
                        }
                    });
                })
                .catch(reason => {
                    let error = reason.response.data.errors;
                    self.error_message_name =
                        error.name != undefined ? error.name.msg : "";
                    self.error_message_lastname =
                        error.lastname != undefined ? error.lastname.msg : "";
                    self.error_message_roll =
                        error.roll != undefined ? error.roll.msg : "";
                    self.error_message_email =
                        error.email != undefined ? error.email.msg : "";
                    self.error_message_password =
                        error.password != undefined ? error.password.msg : "";
                });
        },
        cancel() {
            swal({
                title: this.$t("ARE YOU SURE THAT YOU WANT TO CANCEL"),
                icon: "warning",
                buttons: ["No!", this.$t("YES"), ],
                dangerMode: false
            }).then(willDelete => {
                if (willDelete) {
                    this.$router.go(-1);
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Users/newUser.vue